import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';

import { RangeSliderContainer } from './styles';

class RangeSlider extends Component {
  static propTypes = {
    handleSliderChange: PropTypes.func,
    currentMinValue: PropTypes.number,
    currentMaxValue: PropTypes.number,
  };

  state = {
    value: {
      min: 0,
      max: 0,
    },
  };

  componentDidMount() {
    const { currentMinValue, currentMaxValue } = this.props;
    this.setState({
      value: {
        min: currentMinValue,
        max: currentMaxValue,
      },
    });
  };

  componentDidUpdate(prevProps) {
    const { currentMinValue, currentMaxValue } = this.props;
    const { currentMinValue: prevCurrentMinValue, currentMaxValue: prevCurrentMaxValue } = prevProps;
    if(prevCurrentMinValue !== currentMinValue || prevCurrentMaxValue !== currentMaxValue) {
      this.setState({
        value: {
          min: currentMinValue,
          max: currentMaxValue,
        },
      });
    }
  };

  handleValueChange = value => {
    if (value.min >= 0 && value.max <= 300) {
      this.setState({
        value,
      });
    }
  };

  handleChangeComplete = value => {
    const { handleSliderChange } = this.props;
    handleSliderChange(value);
  };

  render() {
    const { value } = this.state;
    return (
      <RangeSliderContainer>
        <InputRange
          minValue={0}
          maxValue={300}
          value={value}
          formatLabel={val => `$${val}`}
          onChange={this.handleValueChange}
          onChangeComplete={this.handleChangeComplete}
        />
      </RangeSliderContainer>
    );
  }
}

export default RangeSlider;
